<template>
    <ticket-form :action="create"></ticket-form>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { ticketService } from '@/common/api.service'
import ticketForm from './../../ticket/components/form'

export default {
    components: {
        ticketForm
    },
    methods: {
        create(e, query) {
            let form = $(e.target)
            let btn = $('#submit_button')

            form.validate({
                ignore: ":hidden",

                rules: {
                    subject: {
                        required: true,
                    },
                    category_id: {
                        required: true,
                    },
                    content: {
                        required: true,
                    },
                    priority: {
                        required: true,
                    },
                },
            });


            if(!form.valid()) {
                return
            }

            let params = {
                subject: query.subject,
                content: query.content,
                category_id: query.category_id,
                created_for: this.$route.params.hashid,
                priority: query.priority
            }
            

            KTApp.progress(btn)
            ticketService.create(params)
            .then(response => {
                this.showMsg(form, 'success', response.data.message)
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
                KTApp.unprogress(btn)
            })
            .finally(() => {
                KTUtil.scrollTop()
                KTApp.unprogress(btn)
            })
        }
    },
}
</script>

<style>

</style>